import React, { Component } from 'react';
// import { Route } from 'react-router-dom';

class ProjectList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			projects : []            
		};
  }
	
	componentDidMount() {
		this.getProjects();
  }
	
  // Retrieves the list of items from the Express app
  getProjects = () => {
		let projects = [...this.props.donors]
		projects.shift();
		this.setState({ projects });
  }

  openIframe = (project) => {
    console.log(project);
    const selector = project.title.split(" ")[1];
    const allIframes = document.getElementsByClassName("iframe");
    const iframeArray = Object.values(allIframes);
    iframeArray.map((iframe) => {
      iframe.height = "114"
    });

    const iframe = document.getElementsByClassName(selector + "-iframe")[0];
    if (iframe) iframe.height = "840";

    iframe.scrollIntoView({behavior: "smooth"});
  }

	render() {
		const { projects } = this.state;
		
		return (
			<React.Fragment>
				<ul className="project-list">
					<script src="https://donorbox.org/widget.js" paypalexpress="true"></script>
					{projects.map((project, i) => {
					  return (
							<li key={i} className={project.title.split(" ")[1]}>
							  <div className="project-text">
								<div className="project-text-head">
								  <h2 className="project-title">{project.title}</h2>
								  <div className="buttonCTA buttonText" onClick={this.openIframe.bind(this, project)}>
									<p>DONATE</p>
								  </div>
								</div>
								<div className="project-donorbox">
								  <iframe className={project.title.split(" ")[1] + "-iframe"} src={project.opt1} height="120px" width="100%" seamless="seamless" name="donorbox" frameBorder="0" scrolling="no" allowpaymentrequest="true"></iframe>
								</div>
								<div className="project-description"  dangerouslySetInnerHTML={{ __html : project.opt2}}></div>
							  </div>
							</li>
					  )
					})}
			  </ul>
			</React.Fragment>
		)
	}
}

export default ProjectList


// WEBPACK FOOTER //
// ./src/components/donate/projects.js